__turbopack_context__.v({
  "Art": "LeJg2W_Art",
  "Art_0": "LeJg2W_Art_0",
  "Art_1": "LeJg2W_Art_1",
  "Art_2": "LeJg2W_Art_2",
});
